module.exports = __webpack_public_path__ + "static/media/oxford.3f49f998.png";